import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import PatientResults, { Report } from 'modules/PatientResults';
import * as selectors from '../../selectors';
import { getIsNotPrintable } from './helpers';
import styles from './ReportsLayout.pcss';
const Reports = ({ reportRefs, singleReportPrint, downloadCsv, forcePrintState })=>{
    const reportTypes = useSelector(PatientResults.selectors.reportTypes);
    const hideReadingsTable = useSelector(selectors.hideReadingsTable);
    const hideDailyDetails = useSelector(selectors.hideDailyDetails);
    const hideEmptyRows = useSelector(selectors.hideEmptyRows);
    const showDayDividers = useSelector(selectors.showDayDividers);
    const renderReport = (reportType, index)=>{
        const shouldBreakPage = reportTypes.length > 1 && index < reportTypes.length - 1 && !singleReportPrint;
        const dashboardLayout = PatientResults.constants.DASHBOARD_LAYOUTS[reportType];
        const isNotPrintable = getIsNotPrintable(reportType, singleReportPrint);
        if (forcePrintState && isNotPrintable) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.reportsLayout__report, {
                [styles['reportsLayout__report--notPrintable']]: isNotPrintable,
                [styles['reportsLayout__report--breakPage']]: shouldBreakPage
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    ref: reportRefs[reportType],
                    children: /*#__PURE__*/ _jsx(Report, {
                        dashboardLayout: dashboardLayout,
                        downloadCsv: downloadCsv,
                        hideReadingsTable: hideReadingsTable,
                        hideDailyDetails: hideDailyDetails,
                        hideEmptyRows: hideEmptyRows,
                        showDayDividers: showDayDividers
                    })
                }),
                shouldBreakPage && /*#__PURE__*/ _jsx("div", {
                    className: styles.reportsLayout__reportSeparator
                })
            ]
        }, reportType);
    };
    return /*#__PURE__*/ _jsx("div", {
        children: reportTypes.map(renderReport)
    });
};
export default Reports;
